export default "__VITE_ASSET__BilAGsOl__"